import { useMessageApi } from "../../../../provider/AntdNotification";
import ButtonWrapper from "../../../components/reuseComp/ButtonWrapper";
import { Form, Input, Spin, Switch, InputNumber, Button, Card } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UploadFoodImage from "../../../../lib/UploadFoodImage";
import { useAuthorDetails, useAuthorSave } from "../../../../hooks/api/author/hook";

interface Props {
  qData: any;
  id?: any;
}

const AuthorForm: React.FC<Props> = ({ qData, id }) => {
  const [form] = Form.useForm();
  const message = useMessageApi();
  const navigate = useNavigate();
  const isEditPage = Boolean(id);

  const { mutate: saveAuthor, isPending } = useAuthorSave({ qData });
  const { data: authorDetails, isLoading } = useAuthorDetails(id);

  console.log(authorDetails, "author-details");

  useEffect(() => {
    if (isEditPage && authorDetails?.data) {
      form.setFieldsValue(authorDetails.data);
    }
  }, [isEditPage, authorDetails, form]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();

      saveAuthor(
        { ...values, _id: id },
        {
          onSuccess: () => {
            message.success(
              isEditPage
                ? "Author updated successfully"
                : "Author created successfully",
            );
            navigate(-1);
          },
          onError: (error) => {
            console.log(error, "error-saving-author");
          },
        },
      );
    } catch (err) {
      console.error(err);
    }
  };

  const showSpinner = isEditPage && isLoading;

  return (
    <div>
      <div className="bg-[#F9F9F9] p-3 md:p-6 rounded-2xl shadow-sm mb-6">
        <Spin spinning={showSpinner} tip="Loading Service details...">
          <Form layout="vertical" form={form}>
            {/* BASIC INFO */}
            <Form.Item name="_id" hidden>
              <Input />
            </Form.Item>

            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: "Please enter name" }]}
            >
              <Input placeholder="Enter name" />
            </Form.Item>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Form.Item label="Profile Image" name="avatar">
                <UploadFoodImage
                  maxUploadCount={1}
                  isCropTrue={false}
                  bannerAspect={1 / 1}
                  text="Profile Image"
                />
              </Form.Item>

              {/* STATUS + ORDER */}
              <div className="space-y-2">
                <Form.Item
                  label="Status"
                  name="status"
                  valuePropName="checked"
                  rules={[{ required: true, message: "Please select status" }]}
                >
                  <Switch
                    checkedChildren="Active"
                    unCheckedChildren="Inactive"
                  />
                </Form.Item>
              </div>
            </div>
          </Form>
        </Spin>
      </div>

      {/* BUTTONS */}
      <div className="flex justify-start gap-3 mt-7 sticky bottom-5">
        <ButtonWrapper type="primary" onClick={handleSave} loading={isPending}>
          Save
        </ButtonWrapper>
        <ButtonWrapper onClick={() => navigate(-1)}>Cancel</ButtonWrapper>
      </div>
    </div>
  );
};

export default AuthorForm;
